import BoxExample from "../../../../content/blog/css-box-model/BoxExample";
import * as React from 'react';
export default {
  BoxExample,
  React
};